module.exports = __webpack_public_path__ + "img/9_newModelWorker_lh.0b226888.png";